import React, { useState, useEffect } from "react";
import axios from "axios";
import configData from '../configData'
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';



import { FiCheckCircle } from 'react-icons/fi';
import { AiOutlineClose } from 'react-icons/ai';


export default function Pricing() {
    const navigate = useNavigate();
    const location = useLocation();
    const [transactionId, setTransactionId] = useState('');
    // false, matching what the prerenderer captured and what every browser ends
    // at. Starting true meant the saved file and the first client render
    // disagreed about the navbar, and hydration threw the page away. Same fault
    // and same fix as src/pages/pricing.js.
    const [hevolvedroid, setIshevolvedroid] = useState(false);
    const { DataForPricePage } = location.state || {};

    const [numOfStudents, setNumOfStudents] = useState(null);
    // const [showAlert, setShowAlert] = useState(false);
    const [selectedSubscription, setSelectedSubscription] = useState(null);

    const [subscriptionData, setSubscriptionData] = useState(null);
    useEffect(() => {

        if (DataForPricePage && DataForPricePage.num_of_students) {
            setNumOfStudents(DataForPricePage.num_of_students);
        }
    }, [DataForPricePage]);
    useEffect(() => {
        const userAgent = navigator.userAgent;
        setIshevolvedroid(userAgent.includes('hevolvedroid'));


    }, []);

    // const hideAlertAfterDelay = () => {
    //     // Hide the alert after 5 seconds (5000 milliseconds)
    //     setTimeout(() => {
    //         setShowAlert(false);
    //     }, 5000);
    // };

    useEffect(() => {
        const getSubscriptionsByPlans = async () => {
            try {
                const response = await fetch(configData.getsubscriptionsbyplans);

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);

                const showHevolveBusiness = DataForPricePage && DataForPricePage.num_of_students !== undefined && DataForPricePage.num_of_students !== null && DataForPricePage.num_of_students !== '';

                const filteredData = data.filter(subscription => {
                    // Exclude specific prices
                    const excludePrices = [29, 299];
                    const shouldExclude = excludePrices.includes(subscription.price);

                    if (showHevolveBusiness) {
                        return subscription.title === 'Hevolve Business' && !shouldExclude;
                    } else {
                        return subscription.title !== 'Hevolve Business' && !shouldExclude;
                    }
                });


                if (hevolvedroid) {
                    setSubscriptionData(filteredData.filter(subscription => subscription.price !== 0 && subscription.title !== 'Free'));
                } else {
                    setSubscriptionData(filteredData);
                }
            } catch (error) {
                console.error("Error fetching subscriptions:", error.message);
            }
        };

        getSubscriptionsByPlans();
    }, [DataForPricePage, hevolvedroid]);



    const handlePayNowClick = (subscription) => {

        setSelectedSubscription(subscription);
        const uuid = uuidv4();
        const truncatedUuid = uuid.replace(/-/g, '').substring(0, 36);
        const transactionid = "T" + truncatedUuid;
        setTransactionId(transactionid)
        if (hevolvedroid) {


            try {
                var userDetails = window.Handy.getUserDetails();
                const userJson = JSON.parse(userDetails);
                DataForPricePage = userJson;

            }
            catch (error) {
                console.error('Error fetching user details:', error);
            }

            var myVariable = {
                TRANSACTION_ID: transactionId

            };
            const jsTransaction = JSON.stringify(myVariable)
            window.Handy.setTransactionId(jsTransaction);

        }

        const { title, description, price } = subscription;

        const postData = {
            phone_number: DataForPricePage ? DataForPricePage.phone_number : '',
            plan_id: subscription.plan_id,
            transaction_id: transactionid,
        };


        //not for the payment
        axios
            .post(configData.AddSubscriptio_By_Phone, postData)
            .then((response) => {
                // Handle the response, e.g., redirect the user to the payment gateway
                // based on the response from your server



            })
            .catch((error) => {
                console.error('Payment error:', error);
            });


        const payload = {
            mobile_number: DataForPricePage ? DataForPricePage.phone_number : '',
            plan_id: subscription.plan_id,
            transaction_id: transactionid,
            amount: numOfStudents ? subscription.price * numOfStudents : subscription.price

        };

        axios.post(configData.PaymentUrl, payload, {
            headers: {
                'Content-Type': 'application/json',

            },
        })
            .then(response => {

                if (response.status === 200) {
                    const redirect = response.data;
                    window.location.href = redirect
                }
                else {
                    console.error('Request failed with status:', response.status);
                }

            })
            .catch(error => {
                console.error('Error:', error);
            });
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Payment Page Click',
        });



    };


    return (
        <>
            {/* {showAlert && (
                    <Alert style={{textAlign:'center'}} severity="error">Please sign up or login first.</Alert>
                )} */}
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">

                {subscriptionData && subscriptionData.map((subscription) => (
                    <div key={subscription.plan_id} style={{ backgroundColor: '#1E1E1E' }} className="relative overflow-hidden rounded-md shadow dark:shadow-gray-800">
                        <div className="p-6">
                            <h5 className="text-2xl leading-normal font-semibold">{subscription.title}</h5>
                            {/* min-h reserves two lines.
                              *
                              * Without it each card's description sets its own
                              * height, and everything under it slides. Measured
                              * on the live page: "Hevolve+ Pro" has a one-line
                              * description where the other two wrap to two, so
                              * its price sat at y=293 against y=319 for the
                              * others -- 26px out. The button, "FEATURES:" and
                              * every feature row below inherited the offset.
                              *
                              * A pricing table exists to be read ACROSS, so
                              * rows that do not line up defeat the whole
                              * layout. Reserving the taller of the two here is
                              * cheaper and more predictable than a grid
                              * subgrid, and it degrades correctly if a future
                              * plan needs three lines: it grows, and the others
                              * keep their floor. */}
                            <p className="text-slate-400 mt-2 min-h-[3rem]">{subscription.description}</p>
                            <div className="flex mt-4">
                                <span className="text-lg font-semibold">₹</span>
                                <span className="text-5xl font-semibold mb-0 ms-1">
                                    {numOfStudents ? subscription.price * numOfStudents : subscription.price}
                                </span>

                            </div>
                            {/* Rendered "PER MONTH/ FOR  USER" on the live page,
                              * with the doubled space where the count should
                              * be: numOfStudents is empty until the institution
                              * selector sets it, and the template interpolated
                              * it unconditionally. Also said "1 User" as "For 1
                              * User" and would have said "For 5 User". */}
                            <p className="text-slate-400 uppercase text-xs">
                                {numOfStudents > 1
                                    ? `per month / for ${numOfStudents} users`
                                    : 'per month / per user'}
                            </p>



                            <div className="mt-6">

                                {/* One button, not two.
                                  *
                                  * These were two <button> elements identical
                                  * in every attribute except the label, which
                                  * is a copy waiting to drift -- and it already
                                  * had: only one of them carried onClick on its
                                  * own line, and any style fix would have had
                                  * to be made twice.
                                  *
                                  * w-full replaces inline-block on purpose.
                                  * Sized to their text, "Register For Free" and
                                  * "Pay Now" rendered at different widths side
                                  * by side, so the row of calls to action read
                                  * as ragged rather than as a set to choose
                                  * between. */}
                                <button
                                    type="button"
                                    onClick={() => handlePayNowClick(subscription)}
                                    style={{
                                        background: 'linear-gradient(to right, #00e89d, #0078ff)',
                                        backgroundImage: 'linear-gradient(to right, rgb(0, 232, 157), rgb(0, 120, 255))',
                                        borderColor: '#00f0c5',
                                        color: '#FFFAE8',
                                        transition: 'background-color 0.3s ease',
                                    }}
                                    className="py-2 px-5 w-full block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400/5 hover:bg-amber-400 rounded border-amber-400/10 hover:border-amber-400 text-amber-400 hover:text-white"
                                >
                                    {subscription.price === 0 ? 'Register For Free' : 'Get Started'}
                                </button>
                                <p className="text-slate-400 text-sm mt-3">No credit card required. Free 14-days trial</p>
                            </div>
                        </div>

                        <div className="p-6 bg-gray-50 dark:bg-slate-800">
                            <ul className="list-none text-slate-400">
                                <li className="font-semibold text-slate-900 dark:text-white text-sm uppercase">Features:</li>

                                {subscription.features.map((feature, index) => (
                                    <li key={index} className="flex items-center mt-2">
                                        {feature.access ? (
                                            <FiCheckCircle className="text-green-600 h-[18px] w-[18px] me-2" />
                                        ) : (
                                            <AiOutlineClose className=" text-red-600 h-[18px] w-[18px] me-2" />
                                        )}
                                        <span className={`text-slate-900 ${feature.access ? 'dark:text-white' : 'dark:text-white'} me-1 font-semibold`}>{feature.name}</span>
                                        {feature.daily && <span className="text-slate-400 me-1 font-semibold">Daily: {feature.daily}</span>}
                                        {feature.monthly && <span className="text-slate-400 me-1 font-semibold">Monthly: {feature.monthly}</span>}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}


            </div>
        </>
    )
}